import React from 'react';

import {
    Input,
    ListItem,
    ListItemPrimaryText,
    ListItemText,
    ListWrapper,
    Card,
    IconStar,
    INPUT_ICON_POSITIONS
} from 'cdk-radial';

import throttle from 'lodash/throttle';

const autocompleteService = { current: null };
let placeService = null
const ADDRESS_DETAILS_MAP = {
    street_number: 'street',
    route: 'address',
    locality: 'city',
    sublocality: 'city',
    sublocality_level_1 : 'city',
    administrative_area_level_1: 'state',
    country: 'country',
    postal_code: 'zip',
    administrative_area_level_2: 'county'
  };
function loadScript(src, position, id) {
    if (!position) {
        return;
    }

    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('id', id);
    script.src = src;
    position.appendChild(script);
}


const Autocomplete = ( {onAddressSelect} ) => {
    const [value, setValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [error, setError] = React.useState(null);
    const [showOptions, setShowOptions] = React.useState(null);
    const [options, setOptions] = React.useState([]);
    const loaded = React.useRef(false);

    if (typeof window !== 'undefined' && !loaded.current) {
        if (!document.querySelector('#google-maps')) {
            loadScript(
                'https://maps.googleapis.com/maps/api/js?key=AIzaSyCUVckY_24TDL7sVLr2kzHhOUrz-pLufMM&libraries=places',
                document.querySelector('head'),
                'google-maps',
            );
        }

        loaded.current = true;
    }

    const fetch = React.useMemo(
        () =>
            throttle((request, callback) => {
                autocompleteService.current.getPlacePredictions(request, callback);
            }, 200),
        [],
    );


    React.useEffect(() => {
        let active = true;

        if (!autocompleteService.current && window.google) {
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
        }

        if (!placeService && window.google) {
            const mapOptions = {
                center: {
                  lat: 50,
                  lng: 50
                },
                zoom: 5
              };
            const map = new window.google.maps.Map(mapOptions);
            placeService = new window.google.maps.places.PlacesService(map);
           
        }

        if (!autocompleteService.current) {
            return undefined;
        }

        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }

        fetch({ input: inputValue, componentRestrictions: { country: 'us' } }, (results) => {
            if (active) {
                let newOptions = [];

                if (value) {
                    newOptions = [value];
                }

                if (results) {
                    newOptions = results.map(({ place_id, description }) => ({ place_id, description }))
                }

                setOptions(newOptions);
            }
        });

        return () => {
            active = false;
        };
    }, [value, inputValue, fetch]);

    const getPlaceDetails = (value, description) => {
        if (value != null) {
            placeService.getDetails(
                { placeId: value },
                (place, status) => {
                    let sel_Address={};
                    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                        place.address_components.map((address_component)=>{
                        
                            const addressType = address_component.types[0];
                            if(ADDRESS_DETAILS_MAP[addressType]){
                                let key = ADDRESS_DETAILS_MAP[addressType]
                                if(key == 'state' || key =='country'){
                                    sel_Address[key] = address_component.short_name
                                }else{
                                sel_Address[key] = address_component.long_name
                                }
                            }
                        })
                        setInputValue(description)
                        onAddressSelect(sel_Address)
                       
                    }
                    setError(true)
                }
            );
        }
    };

    return (
        <div className="autocomplete-div">
            <Input
                label="Address"
                fullWidth
                hasError={error}
                value={inputValue}
                onChange={(e) => {
                    setError(false);
                    setShowOptions(true);
                    setInputValue(e.target.value)
                }
                }
                icon={<IconStar />} iconPosition={INPUT_ICON_POSITIONS.TRAILING}
            />
           {showOptions &&  <Card className="autocomplete-options">
                <ListWrapper style={{
                    width: '300px',
                    backgroundColor: '#fff'
                }}>
                    {options.map(({ place_id, description }) => (<ListItem onClick={() => { 
                        setShowOptions(false)
                        getPlaceDetails(place_id, description) 
                        }} key={place_id} size="large">
                        <ListItemText>
                            <ListItemPrimaryText>{description}</ListItemPrimaryText>
                        </ListItemText>
                    </ListItem>)
                    )}
                </ListWrapper>
            </Card>}
        </div>
    );
}

export default Autocomplete